export default __webpack_public_path__ + "static/media/cx_cover_tln1s.1a6b32f9.jpg";